import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class DataProcessingAgreementApi extends BaseApi {
    constructor(client) {
        super(client, '/data-processing-agreement');
    }

    async getByVendor(vendorId) {
        try {
            const response = await this.client.get(`${this.basePath}/by-vendor/${vendorId}`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async addSubProcessor(id, data) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/sub-processors`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async decideSubProcessor(id, subId, data) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/sub-processors/${subId}/decide`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
